module.exports = __webpack_public_path__ + "img/free_ongkir.776f830d.svg";